import React, { useEffect, useState } from 'react';
import { Table, Pagination } from '@alifd/next';
import { Box } from '@mui/material';
import EditButton from './Buttons/EditButton';
import DeleteButton from './Buttons/DeleteButton';
import ViewButton from './Buttons/ViewButton';

const Column = Table.Column;

const ManipulateButton = {
  ViewButton,
  EditButton,
  DeleteButton,
};

export default function DynamicTable({
  dynamicStructure = { dbName: '', funcs: [], fields: {}, manipulate: [] },
  data = [],
  setIsUpdate = () => {},
  setSelectedVendor = () => {},
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [dataSource, setDataSource] = useState([]);
  const [showData, setShowData] = useState([]);
  const initialSort = { field: 'createTime', order: 'asc' };
  const [sort, setSort] = useState(initialSort);

  const { dbName, fields, manipulate } = dynamicStructure;

  useEffect(() => {
    setCurrentPage((prev) => {
      if (data.length <= (prev - 1) * 10) {
        return prev - 1;
      }
      if (prev === 0 && data.length > 0) {
        return 1;
      }
      return prev;
    });
    // setDataSource(data);
    setDataSource((prev) => {
      if (data.length > 0) {
        const newData = [...data];
        return newData.sort((a, b) => {
          const elA = a[sort.field].toString();
          const elB = b[sort.field].toString();
          return elA.localeCompare(elB) * (sort.order === 'asc' ? 1 : -1);
        });
      }
      return prev;
    });
  }, [data, sort]);

  useEffect(() => {
    setCurrentPage(1);

    setDataSource((prev) => {
      if (prev.length > 0) {
        const newData = [...prev];
        return newData.sort((a, b) => {
          const elA = a[sort.field].toString();
          const elB = b[sort.field].toString();
          return elA.localeCompare(elB) * (sort.order === 'asc' ? 1 : -1);
        });
      }
      return prev;
    });
  }, [sort]);

  useEffect(() => {
    setShowData(dataSource.slice((currentPage - 1) * 10, currentPage * 10));
  }, [currentPage, dataSource]);

  const handleSort = (field = '', order = '') => {
    setSort({ field, order });
  };

  return (
    <Box
      sx={{
        borderRadius: '5px',
        backgroundColor: '#fff',
        marginTop: '10px',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'end',
        gap: '20px',
      }}
    >
      {Object.keys(dynamicStructure.fields).length > 0 && (
        <>
          <Table
            dataSource={showData}
            onSort={handleSort}
            sort={{ [sort.field]: sort.order }}
          >
            {Object.values(fields).map((field) => {
              return <Column key={field.name} {...field.column.props} />;
            })}
            {manipulate?.length > 0 && (
              <Column
                title="操作"
                dataIndex="_id"
                width={200}
                lock="right"
                cell={(value, _index, record) => {
                  return (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                      }}
                    >
                      {manipulate.map((func) => {
                        const Func = ManipulateButton[func.type];

                        return (
                          <Func
                            key={`${value}-${func.type}`}
                            {...{
                              dbName,
                              func,
                              fields,
                              defaultValue: record,
                              setIsUpdate,
                              setSelectedVendor,
                              //   record.tableName + '-' + record.companyId,
                            }}
                          />
                        );
                      })}
                    </Box>
                  );
                }}
              />
            )}
          </Table>
          <Pagination
            total={dataSource.length}
            current={currentPage}
            onChange={(page) => {
              setCurrentPage(page);
            }}
            style={{ alignSelf: 'end' }}
          />
        </>
      )}
    </Box>
  );
}
